export default __webpack_public_path__ + "static/media/active-clock-icon-luxe.f365abb4a71847a738c13e74cbacdeaa.svg";